import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import FormField from '../form-field';
import { formatMessage } from '../../lib/intl';
import '../../css/embedded-signup.css';

const i18n = defineMessages({
  emailLabel: {
    id: 'commitForm.signup.organizer.emailField.label',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'commitForm.signup.organizer.emailField.placeholder',
    defaultMessage: 'Enter an email',
  },
  passwordLabel: {
    id: 'commitForm.signup.organizer.passwordField.label',
    defaultMessage: 'Password',
  },
  passwordPlaceholder: {
    id: 'commitForm.signup.organizer.passwordField.placeholder',
    defaultMessage: 'Enter a password',
  },
})

class SignupAsOrganizer extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  renderPasswordSubText() {
    return (
      <span className="small-print">
        <FormattedMessage
          id="commitForm.signup.organizer.passwordField.subtext"
          defaultMessage="Required for secure access to manage your group"
        />
      </span>
    );
  }

  render() {
    return (
      <div className="embedded-registration">
        <div className="row no-gutters signup-form">
          <div className="col-6 email-input-wrapper">
            <Field
              name="email"
              type="email"
              placeholder={this.formatMessage(i18n.emailPlaceholder)}
              component={FormField}
              label={this.formatMessage(i18n.emailLabel)}
              onChange={this.props.onEmailChange}
              required
              disabled
            />
          </div>
          <div className="col-6">
            <Field
              name="password"
              type="password"
              component={FormField}
              label={this.formatMessage(i18n.passwordLabel)}
              placeholder={this.formatMessage(i18n.passwordPlaceholder)}
              subtext={this.renderPasswordSubText()}
              required
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SignupAsOrganizer);



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/signup.organizer.js